













































import { useRouter, useStore } from '@/hooks/common'
import { createComponent, ref, onMounted, watch, computed, reactive } from '@vue/composition-api'
import { getFileListByNameAndTime, IFileItem } from '../service/public'
import { Message, Tree } from 'element-ui'
import { mkdir, copyMoveFile } from '@/service/public'
import { cloneDeep } from 'lodash'

interface TreeNodeType {
    label: string
    id: string
    key: string
    children: TreeNodeType[]
    expanded: boolean
}

interface InitPropsType {
    imgInfo: IFileItem
}
export default createComponent({
    name: 'NewFoldTree',
    props: {
        imgInfo: {
            type: Object,
            default: () => {
                return {}
            },
        },
    },

    setup(props: InitPropsType, { root, emit }) {
        const router = useRouter()
        const store = useStore()
        const treeRef = ref<Tree>(void null)
        const activeNode = ref<TreeNodeType>({})
        const inputId = ref('')
        const isHighLight = ref(true)
        const isCreating = ref(false)

        const defaultProps = {
            label: 'name',
            isLeaf: 'isFile',
        }
        const newDirName = ref('')
        const reqParams = reactive({
            id: '',
            current: 1,
            size: 1000, // 全量数据暂时设为1000 不分页
            name: '',
            start: '',
            end: '',
        })
        const loadNode = async (node, resolve) => {
            // if (node.level === 0) {
            //   return resolve([
            //     {
            //       name: "根目录",
            //       id: 0,
            //       key: 0,
            //       isFile: false
            //     }
            //   ]);

            // }
            reqParams.id = node.key || 0
            try {
                const currentDirData = await getFileListByNameAndTime(reqParams)
                if (currentDirData.data.length > 0) {
                    const res = (currentDirData.data as IFileItem[]).filter(item => {
                        return !item.isFile
                    })
                    return resolve(res)
                } else {
                    resolve([])
                }
            } catch (error) {
                resolve([])
            }
        }

        const cancelCreate = () => {
            if (isCreating.value && inputId.value) {
                treeRef.value.remove(inputId.value)
                isCreating.value = false
                inputId.value = ''
            }
        }
        const handleNodeExpand = () => {
            cancelCreate()
        }
        const handleNodeCollapse = () => {
            cancelCreate()
        }
        const postNewDir = async () => {
            const reg = /^[()0-9a-zA-Z\u4e00-\u9fa5_（）-]+$/
            if (!reg.test(newDirName.value)) {
                Message.error('名称只能包含数字字母汉字、下划线横线和括号')
                return
            }
            const postData = {
                parentId: activeNode.value.key as string,
                name: newDirName.value,
            }
            const res = await mkdir(postData)
            if (res.code === 0) {
                reqParams.id = activeNode.value.key
                try {
                    const currentDirData = await getFileListByNameAndTime(reqParams)
                    if (currentDirData.data.length > 0) {
                        const res = (currentDirData.data as IFileItem[]).filter(item => {
                            return !item.isFile
                        })
                        treeRef.value.updateKeyChildren(activeNode.value.key, res)
                    } else {
                        cancelCreate()
                    }
                } catch (error) {
                    console.log(error)
                    cancelCreate()
                }
            } else {
                Message.error(res.desc)
                cancelCreate()
            }
            isCreating.value = false
            store.commit('publicStore/SET_NEW_DIR_NAME', '新建文件夹')
            await store.dispatch('publicStore/getTableData')
        }
        const moveDir = async () => {
            const list = [props.imgInfo]
            if (!activeNode.value.key) return
            const target = {
                id: activeNode.value.key,
                name: activeNode.value.label,
            }
            const currentDirId = props.imgInfo.parentId as string
            emit('move-file', { list, currentDirId, target })
        }
        const makeDir = async () => {
            if (isCreating.value) return false
            isCreating.value = true
            inputId.value = `makeDir${new Date().getTime()}`
            const newChild = {
                id: inputId.value,
                label: '新建文件夹',
                isFile: true,
            }
            if (!activeNode.value.expanded) {
                activeNode.value.expanded = true
            }
            treeRef.value.append(newChild, activeNode.value)
            setTimeout(() => {
                const ele = document.querySelector('.new-dir') as HTMLInputElement
                ele.focus()
            }, 0)
        }
        const renderContent = (h, { node, data, store }) => {
            if (String(node.key) === inputId.value) {
                return h('input', {
                    attrs: {
                        class: 'new-dir',
                    },
                    on: {
                        input: e => {
                            newDirName.value = e.target.value
                        },
                    },
                })
            } else {
                return h(
                    'div',
                    {
                        attrs: {
                            class: 'node-span-box',
                        },
                    },
                    [
                        h(
                            'span',
                            {
                                on: {
                                    click: e => {
                                        e.target.parentNode.parentNode.firstChild.click()
                                        activeNode.value = node
                                        isHighLight.value = true
                                        cancelCreate()
                                    },
                                },
                            },
                            node.label
                        ),
                    ]
                )
            }
        }
        return {
            treeRef,
            activeNode,
            defaultProps,
            isHighLight,
            loadNode,
            postNewDir,
            cancelCreate,
            handleNodeExpand,
            handleNodeCollapse,
            isCreating,
            renderContent,
            makeDir,
            moveDir,
        }
    },
})
